//import * as d3 from 'd3';
//import L from 'leaflet';
//import * as LPattern from 'leaflet.pattern';
import * as chroma from 'chroma-js';

//var stripes = new L.StripePattern();

export function onEveryFeatureMeters(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.name + '<br></br>' + feature.properties.label);
  }
}

export function onEveryFeatureTreatment(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.Name);
  }
}

function getLLCColor(entity) {
  switch (entity) {
    case "MP West, LLC":
      return '#c0392b';

    case "MP CPR, LLC":
      return '#95a5a6';

    case "MP EMI, LLC":
      return '#3498db';

    case "MP Central A, LLC":
      return '#f39c12';

    case "MP Central B, LLC":
      return '#8e44ad';

    case "MP East A, LLC":
      return '#273c75';

    case "MP East B, LLC":
      return '#2ecc71';

    default:
      return null;
  }
}

var llc_color;
export function style_llcs(feature){
  llc_color = getLLCColor(feature.properties.lgl_ntt);
  return {
    color: llc_color,
    opacity: 0,
    fillColor: llc_color,
    fillOpacity: 0.6,
    weight: 1.5,
    zIndex: 452
  };
}

function getIssueColor(issue) {
  switch (issue) {
    case "MP West, LLC":
      return '#c0392b';

    case "MP CPR, LLC":
      return '#95a5a6';

    case "MP EMI, LLC":
      return '#3498db';

    case "MP Central A, LLC":
      return '#f39c12';

    case "MP Central B, LLC":
      return '#8e44ad';

    case "MP East A, LLC":
      return '#273c75';

    case "MP East B, LLC":
      return '#2ecc71';

    default:
      return null;
  }
}

var issue_color;
export function style_issues(feature){
  issue_color = getIssueColor(feature.properties.lgl_ntt);
  return {
    color: issue_color,
    opacity: 0,
    fillColor: issue_color,
    fillOpacity: 0.6,
    weight: 1.5,
    zIndex: 452
  };
}

export function onEveryFeatureLLC(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.lgl_ntt);
  }
}

export function style_outline_properties(feature){
  return {
    color: 'grey',
    opacity: 0.7,
    fillColor: 'white',
    fillOpacity: 0,
    weight: 0.6
  };
}

export function style_properties(feature){
  return {
    color: '#3e3e3f',
    opacity: 1,
    fillColor: 'white',
    fillOpacity: 0.3,
    weight: 1.5
  };
}

export function style_properties_cpr(feature){
  return {
    color: '#3e3e3f',
    opacity: 1,
    fillColor: '#ff6e00',
    fillOpacity: 0.3,
    weight: 1.5
  };
}

export function style_properties_cpr_no_sub(feature){
  return {
    color: '#3e3e3f',
    opacity: 1,
    fillColor: '#6e00ff',
    fillOpacity: 0.3,
    weight: 1.5
  };
}

export function style_ditches(feature){
  return {
    color: '#1034A6',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_emi_ditches(feature){
  return {
    color: '#00CED1',
    weight: 2.5
  };
}

export function style_emi_streams(feature){
  return {
    color: '#E3CF57',
    weight: 2.5
  };
}

export function style_old_roads(feature){
  return {
    color: '#FFD300',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_water(feature){
  return {
    fillColor: '#00B2EE',
    color: '#00688B',
    weight: 0.6,
    zIndex: 2
  };
}

export function style_fuel_tanks(feature){
  return {
    fillColor: '#ffa500',
    color: "#cc8400",
    opacity: 0.8,
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_cade(feature){
  return {
    color: '#cc99a2',
    opacity: 0.8,
    fillColor: '#e5acb6',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_solar(feature) {
  return {
    color: '#C67171',
    opacity: 0.8,
    fillColor: '#DC143C',
    fillOpacity: 0.8,
    weight: 0.6
  }
}

export function style_aes_aoi(feature) {
  return {
    color: '#FFEA00',
    opacity: 1,
    fillColor: '#FFEA00',
    fillOpacity: 0.2,
    weight: 0.8,
    dashArray: '12, 6'
  }
}

function getLimitationColor(limitation) {
  switch (limitation) {
    case "Yes":
      return '#eed202';

    case "No":
      return '#b33a3a';

    default:
      return '#FF9933';
  }
}

var limitation_color;
export function style_farming(feature){
  limitation_color = getLimitationColor(feature.properties.Farmable);
  return {
    color: limitation_color,
    opacity: 0,
    fillColor: limitation_color,
    fillOpacity: 0.6,
    weight: 1.5,
    zIndex: 452
  };
}

export function style_camps(feature){
  return {
    color: '#66b266',
    opacity: 0.7,
    fillColor: '#99cc99',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_comm_ind_use(feature){
  return {
    color: '#741b47',
    opacity: 0.7,
    fillColor: '#894366',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_dumps(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_pineapple_fields(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

export function style_pineapple_pesticides(feature){
  return {
    color: '#FF1493',
    opacity: 0.8,
    fillColor: '#FF69B4',
    fillOpacity: 0.8,
    weight: 0.6
  };
}


function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

var color;
export function style_fields(feature){
  color = getRandomColor();
  return {
    color: color,
    fillColor: color,
    fillOpacity: 0.6,
    weight: 0.6,
    zIndex: 452
  };
}

export let style_fields_mono = {
  color: '#b58b1d',
  fillColor: '#b58b1d',
  fillOpacity: 0.6,
  weight: 0.6,
  zIndex: 452
};

export let style_fields_outline = {
  color: '#b5b11d',
  fillColor: '#b5b11d',
  fillOpacity: 0.0,
  weight: 0.6,
  zIndex: 452
};

export let style_parcels_outline = {
  color: '#b51d21',
  fillColor: '#b51d21',
  fillOpacity: 0.0,
  weight: 0.6,
  zIndex: 452
};

export let style_parcels_purchase = {
  color: '#013b45',
  fillColor: '#00b4d4', 
  fillOpacity: 0.9,
  weight: 0.6,
  zIndex: 452
};

export let style_parcels_a = {
  color: '#330127',
  fillColor: '#75055b', //#1acff0
  fillOpacity: 0.9,
  weight: 0.6,
  zIndex: 452
};

export let style_parcels_east = {
  color: '#00b4d4',
  fillColor: '#00b4d4',
  fillOpacity: 0.2,
  weight: 0.6,
  zIndex: 452
};

export let style_fields_2021 = {
  color: '#808080',
  opacity: 0.5,
  fillColor: '#07889b',
  fillOpacity: 0.7,
  weight: 0.6,
  zIndex: 452
};

export let style_fields_west_2021 = {
  color: '#808080',
  opacity: 0.5,
  fillColor: '#f7b733',
  fillOpacity: 0.7,
  weight: 0.6,
  zIndex: 452
};

export let style_fields_2022 = {
  color: '#808080',
  opacity: 0.5,
  fillColor: '#f53240',
  fillOpacity: 0.7,
  weight: 0.6,
  zIndex: 452
};

export function onEveryFeatureEast(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.cty_tmk);
  }
}

export function onEveryFeatureEastLabels(feature, layer){
  if (feature.properties) {
    layer.bindPopup(feature.properties.cty_tmk).bindTooltip(feature.properties.cty_tmk, { permanent: true, direction: 'center', className: "my-label parcel-label", offset: [0, 0] })
  }
}

export function onEveryFeatureMilitary(feature, layer){
  if (feature.properties.Type) {
    layer.bindPopup(feature.properties.Type);
  } else if(feature.properties.Area) {
    layer.bindPopup(feature.properties.Area);
  }
}

//var otherColors = chroma.scale(['#fafa6e','#2A4858']).mode('lch').colors(16)

export function style_other(feature){
  return {
    color: '#96572a',
    opacity: 0.8,
    fillColor: '#b98f71',
    fillOpacity: 0.8,
    weight: 0.6
  };
}

//var seepRadii = d3.scaleLinear().domain([0,50,200,500,3000,57000]).range([3,4,5,6,7,8])


export let style_cesspools = {
  radius: 5,
  color: '#39ff14',
  opacity: 0.8,
  fillColor: '#39ff14',
  fillOpacity: 0.8,
  weight: 0.6
};

export let style_wells = {
  radius: 4,
  fillColor: '#62c896',
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_wells_dom = {
  radius: 4,
  fillColor: "#e75649",
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};


export let style_wells_mun = {
  radius: 4,
  fillColor: "#092e6e",
  color: "#A9A9A9",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_fuel_wells = {
  radius: 4,
  fillColor: '#ffa500',
  color: "#cc8400",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_cemeteries = {
  radius: 4,
  fillColor: '#a1ee33',
  color: "#42b97c",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_points = {
  radius: 4,
  fillColor: '#b51d6d',
  color: "#b51d6d",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_polygons = {
  fillColor: '#b51d6d',
  color: "#b51d6d",
  fillOpacity: 0.3,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_pumps = {
  radius: 4,
  fillColor: '#e50000',
  color: "#b20000",
  fillOpacity: 0.8,
  weight: 0.6,
  zIndex: 15
};

export let style_carve_outs = {
  fillColor: '#e50000',
  //fillPattern: stripes,
  color: "#103A46",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_mills = {
  fillColor: '#69656f',
  color: "#293249",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_landfills = {
  fillColor: '#f6ae99',
  color: "#ff3860",
  fillOpacity: 0,
  opacity: 0.8,
  weight: 1.2,
  zIndex: 15
};

export let style_state_land = {
  fillColor: '#2E8B57',
  color: "#2E8B57",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_endangered_species = {
  fillColor: '#008080',
  color: "#008080",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_transformers = {
  fillColor: '#A52A2A',
  color: "#A52A2A",
  fillOpacity: 0.5,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_military_areas = {
  fillColor: '#CC1100',
  color: "#CC1100",
  fillOpacity: 0.0,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_farmable_acres = {
  fillColor: '#03AC13',
  color: "#028A0F",
  fillOpacity: 0.8,
  opacity: 0.9,
  weight: 1.2,
  zIndex: 15
};

export let style_wahaiwa_parcels = {
  fillColor: '#281E5D',
  color: "#281E5D",
  fillOpacity: 0.6,
  opacity: 1.0,
  weight: 1.2,
  zIndex: 15
};

export function onEveryFeatureWahaiwa(feature, layer){
  if (feature.properties) {
    layer.bindPopup(
      '<b>TMK: </b><p>' + feature.properties.APN + '</p></br>' +
      '<b>Acres: </b>' + Math.round(feature.properties.Acres) + '</br>' +
      '<b>Owner: </b>' + feature.properties.Owner + '</br>' +
      '<b>Dole Owned in 2007?: </b><p>' + feature.properties.Dole + '</p></br>' +
      '<b>Current Use: </b>' + feature.properties.Use + '</br>'
    )
  }
}

function getIssueColor(owner) {
  switch (owner) {
    case "A & B":
      return '#003060'

    case "Mahi Pono":
      return '#b51d6d';

    case "Both":
      return '#FFE800';

    default:
      return null;
  }
}

export function style_issues_polygons(feature) {
  return {
    fillColor: getIssueColor(feature.properties.Owner),
    color: getIssueColor(feature.properties.Owner),
    fillOpacity: 0.3,
    opacity: 0.8,
    weight: 1.2,
    zIndex: 15
  }
};

function getDoleColor(group) {
  switch (group) {
    case "Marketed But Not Under Contract":
      return '#FFBA01'

    case "Parcels Under Contract":
      return '#E27B1C';

    case "Dole Owned and Not Marketed":
      return '#FFE800';

    default:
      return null;
  }
}

export function style_dole_parcels(feature) {
  return {
    fillColor: getDoleColor(feature.properties.Group),
    color: "#000000",
    fillOpacity: 0.8,
    opacity: 1.0,
    weight: 1.2,
    zIndex: 15
  }
};

export function onEveryFeatureDole(feature, layer){
  if (feature.properties) {
    layer.bindPopup(
      '<b><u>' + feature.properties.Group + '</u></b></br>' +
      '<b>TMK: </b><p>' + feature.properties.APN + '</p></br>' +
      '<b>Acres: </b>' + Math.round(feature.properties.Acres) + '</br>' +
      '<b>Current Use: </b>' + feature.properties.Use + '</br>'
    )
  }
}

export let style_comps_parcels = {
  fillColor: '#9B1003',
  color: "#000000",
  fillOpacity: 0.8,
  opacity: 1.0,
  weight: 1.2,
  zIndex: 15
};

export function onEveryFeatureComps(feature, layer){
  if (feature.properties) {
    layer.bindPopup(
      '<b>TMK: </b><p>' + feature.properties.APN + '</p></br>' +
      '<b>Buyer: </b><p>' + feature.properties.Buyer + '</p></br>' +
      '<b>Seller: </b><p>' + feature.properties.Seller + '</p></br>' +
      '<b>Acres: </b>' + Math.round(feature.properties.Acres) + '</br>'
    )
  }
}

export function onEveryFeatureProperties(feature, layer){
  if (feature.properties) {
      //layer.bindPopup('<b>TMK:</b> ' + feature.properties.tmk);
  }
}

var note = null;
export function onEveryFeatureFarming(feature, layer){
  if (feature.properties.Desc) {
    note = feature.properties.Farmable === 'No' ? 'Do Not Farm' : 'Farm with Caution';
    layer.bindPopup(
      '<b>Description: </b><p>' + feature.properties.Desc + '</p></br>' +
      '<b>Farmable Status: </b>' + note + '</br>' +
      '<b>Reason/Comment: </b><p>' + feature.properties.Reason + '</p></br>' +
      '<b>HC&S Fields: </b>' + feature.properties.Fields + '</br>' +
      '<b>TMKs Affected: </b>' + feature.properties.TMKs + '</br>'
    )
  }
}

export function onEveryFeatureIssue(feature, layer){
  var owner = feature.properties.Owner ? (feature.properties.Owner === 'Both' ? 'Split' : feature.properties.Owner) : '' 
  if (feature.properties.Name) {
    layer.bindPopup('<b>' + feature.properties.Type + '</b></br>' + feature.properties.Name + '</br>Owner: ' + owner)
  } else {
    layer.bindPopup('<b>' + feature.properties.Type + '</b></br>Owner: ' + owner)
  }
}

export function onEveryFeatureIssueLabels(feature, layer) {
  if(feature.properties.Type === 'Cesspool') {
    if (feature.properties.Name) {
      layer.bindPopup('<b>' + feature.properties.Type + '</b></br>' + feature.properties.Name + '</br>(Location may be inaccurate.)').bindTooltip(feature.properties.Type + '</br>' + feature.properties.Name + '</br>(Location may be inaccurate.)', { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
    } else {
      layer.bindPopup('<b>' + feature.properties.Type + '</b></br>(Location may be inaccurate.)').bindTooltip(feature.properties.Type + '</br>(Location may be inaccurate.)', { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
    }
  } else {
    if (feature.properties.Name) {
      layer.bindPopup('<b>' + feature.properties.Type + '</b></br>' + feature.properties.Name).bindTooltip(feature.properties.Type + '</br>' + feature.properties.Name, { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
    } else {
      layer.bindPopup('<b>' + feature.properties.Type + '</b>').bindTooltip(feature.properties.Type, { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
    }
  }
}

export function onEveryFeatureParcelsLabels(feature, layer){
  if (feature.properties.cty_tmk) {
    layer.bindPopup('<b>TMK:</b> ' + feature.properties.cty_tmk).bindTooltip(feature.properties.cty_tmk, { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
  } else {
    layer.bindPopup('<b>TMK:</b> No Official TMK')
  }
}

export function onEveryFeatureFields(feature, layer){
  if (feature.properties.Name) {
    layer.bindPopup('<b>Field:</b> ' + feature.properties.Name + '</br><b>Acres:</b> ' + feature.properties.gisacrs)
  } else {
    layer.bindPopup('<b>Field:</b> No Field Name</br><b>Acres:</b> ' + feature.properties.gisacrs)
  }
}

export function onEveryFeatureFieldsLabels(feature, layer){
  if (feature.properties.Name) {
    layer.bindPopup('<b>Field:</b> ' + feature.properties.Name + '</br><b>Acres:</b> ' + feature.properties.gisacrs).bindTooltip(feature.properties.Name, { permanent: true, direction: 'auto', className: "my-label", offset: [0, 0] })
  } else {
    layer.bindPopup('<b>Field:</b> No Field Name</br><b>Acres:</b> ' + feature.properties.gisacrs)
  }
}

export function onEveryFeatureWells(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Well:</b> ' + feature.properties.WELL_NAME +
        '</br><b>Type:</b> ' + feature.properties.WELL_TYPE +
        '</br><b>Use:</b> ' + feature.properties.well_use +
        '</br><b>Depth:</b> ' + feature.properties.WELL_DEPTH
      );
  }
}

export function onEveryFeatureCesspools(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Cesspool</b>' +
        '</br><b>Source:</b> ' + feature.properties.source +
        '</br>(Location may be inaccurate.)'
      );
  }
}

export function onEveryFeatureFuelWells(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Well:</b> ' + feature.properties.Name
      );
  }
}

export function onEveryFeatureWater(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Name:</b> ' + (feature.properties.gnis_name ? feature.properties.gnis_name : '') +
        '</br><b>Type:</b> ' + feature.properties.ftr_typ +
        '</br><b>Description:</b> ' + feature.properties.dscrptn
      );
  }
}

export function onEveryFeatureRes(feature, layer){
  if (feature.properties) {
      layer.bindPopup(feature.properties.Name);
  }
}

export function onEveryFeatureFuelTanks(feature, layer){
  if (feature.properties) {
      layer.bindPopup('<b>Type:</b> ' + feature.properties.Name
      );
  }
}

/*export const MauiParcelsOptions = {
  type: 'protobuf',
  url: '/api/overlay/parcels/{z}/{x}/{y}.pbf',
  subdomains: 'abc',
  zIndex: 299,
  popup: (feature) => `<div><b>TMK:</b> ${feature.properties.tmk_txt}</div>`,
  fetchOptions: { credentials: 'include', headers: { Authorization: 'Bearer ' + sessionStorage.getItem('jwt'), 'Content-Type': 'application/json' } },
  vectorTileLayerStyles: {
    geojsonLayer: {
      fill: true,
      color: '#D9831F',
      fillColor: '#D9831F',
      fillOpacity: 0.0,
      weight: 0.8,
      zIndex: 299
    }
  }
}

export const ContoursOptions = {
  type: 'protobuf',
  url: '/api/mbtiles/{z}/{x}/{y}.pbf',
  subdomains: 'abc',
  zIndex: 299,
  tooltip: (feature) => `<div>${feature.properties.ELEV_ft} ft</div>`,
  popup: (feature) => `<div>${feature.properties.ELEV_ft} ft</div>`,
  fetchOptions: { credentials: 'include', headers: { Authorization: 'Bearer ' + sessionStorage.getItem('jwt'), 'Content-Type': 'application/json' } },
  vectorTileLayerStyles: {
    contours_20ft: {
      weight: 1.2,
      color: '#25221E',
      dashArray: '5, 2',
      fillOpacity: 0
    },
    contours_50ft: {
      weight: 1.2,
      color: '#25221E',
      dashArray: '5, 2',
      fillOpacity: 0
    },
    contours_100ft: {
      weight: 1.2,
      color: '#25221E',
      dashArray: '5, 2',
      fillOpacity: 0
    },
    contours_200ft: {
      weight: 1.2,
      color: '#25221E',
      dashArray: '5, 2',
      fillOpacity: 0
    }
  }
}*/

/*
// Crop Fields Layer - added May 2020
const fieldCrops = [
  'Cattle / Cattle Forage Crop',
  //'Row Crops (Kale/Onion etc.)',
  'Row Crops',
  'Community Farm',
  'Citrus',
  //'Papaya / Tropical Fruit',
  'Tropical Fruit',
  'Avocado',
  'Macadamia Nut',
  'Coffee'
]
const fieldColors = chroma.scale(['#243700','#3d5c00','#51712C','#6e8b0c','#c7af00','#f4d322','#b4a245','#cabd7c']).mode('lch').colors(fieldCrops.length)
//const fieldColors = chroma.scale(['#3d5c00','#51712C','#6e8b0c','#c7af00','#f4d322','#b4a245']).mode('lch').colors(fieldCrops.length)
*/

const fieldCrops = ['Row Crops', 'Community Farm', 'Avocado', 'Cattle / Cattle Forage Crop', 'Macadamia Nut', 'Citrus', 'Tropical Fruit', 'Coffee']
const fieldColors = ['#1f4408','#3d5c00','#51712C','#6e8b0c','#c7af00','#f4d322','#e0a038','#604f0a'];

export function style_fields_crops (feature) {
  if (feature.properties.Field === '718'){ 
    return {
      color: '#3e3e3f',
      opacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.3) : 0.5,
      fillColor: feature.properties.Crop ? fieldColors[fieldCrops.indexOf('Row Crops')] : '#ffffff',
      fillOpacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.4) : 0.5,
      weight: 1
    }
  } else {
    return {
      color: '#3e3e3f',
      opacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.3) : 0.5,
      fillColor: feature.properties.Crop ? fieldColors[fieldCrops.indexOf(feature.properties.Crop)] : '#ffffff',
      fillOpacity: feature.properties.Planted ? (feature.properties.Planted === 'Y' ? 1.0 : 0.4) : 0.5,
      weight: 1
    }
  }
}

export function onEveryFeatureFieldsCrops(feature, layer){
  // let planted = feature.properties.Planted === 'Y' ? 'Planted' : 'Future Crop'; // updated for 2022 layer
  if (feature.properties.Field) {
    // layer.bindPopup('<b>Field ' + feature.properties.Field + '</b></br>' + feature.properties.Crop + '</br>' + planted ) // updated for 2022 layer
    layer.bindPopup('<b>Field ' + feature.properties.Field + '</b></br>' + (feature.properties.Crop_Label ? feature.properties.Crop_Label : '--') + '</br>' + (feature.properties.Status ? feature.properties.Status : '--') ) // updated for 2022 layer
    .bindTooltip(feature.properties.Field, { permanent: true, direction: 'center', className: "my-label field-label", offset: [0, 0] })
  }
}



// WEBPACK FOOTER //
// ./src/components/MapView/overlay_styles.js